import React from "react";
import Keyboardone from "./keyboardone";
const Keyboards = () => {
  return (
    <div>
      <Keyboardone />
    </div>
  );
};

export default Keyboards;
